var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "form-group mt-3", class: { "has-error": _vm.error } },
    [
      _c("div", { staticClass: "row g-3 align-items-center" }, [
        _vm.label
          ? _c(
              "label",
              {
                class: [_vm.labelWidthClass, _vm.required ? "is-required" : ""],
                attrs: { for: _vm.for_label, id: _vm.for_label + "_label" },
              },
              [
                _vm._t("label", function () {
                  return [_vm._v(_vm._s(_vm.label))]
                }),
                _vm._v(" "),
                _vm.aria
                  ? _c("span", { staticClass: "sr-only" }, [
                      _vm._v(_vm._s(_vm.aria)),
                    ])
                  : _vm._e(),
              ],
              2
            )
          : _vm._e(),
        _vm._v(" "),
        !_vm.label ? _c("div", { class: _vm.labelWidthClass }) : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          { class: _vm.controlWidthClass },
          [
            _vm._t("default"),
            _vm._v(" "),
            _vm.error
              ? _c("p", {
                  staticClass: "error",
                  domProps: { innerHTML: _vm._s(_vm.error) },
                })
              : _vm._e(),
          ],
          2
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          {
            class:
              _vm.descriptionWidthClass + " col-sm-offset-" + _vm.labelWidth,
          },
          [_c("div", { staticClass: "form-control-description" })]
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }